import { ButtonCollection } from "@components/ButtonCollection/ButtonCollection";
import { CMSBlock } from "@jwm/types/CMSBlock";
import { CMSFootnotes } from "@jwm/types/CMSFootnotes";
import { mapButtonProps } from "@utils/cms-mapper/mapButtonProps";
import React from "react";

interface ButtonCollectionBlockProps {
    content: CMSBlock["button_collection"];
    placement?: string;
    footnotes?: CMSFootnotes[];
}

export const ButtonCollectionBlock = ({ content }: ButtonCollectionBlockProps): JSX.Element => {
    const buttons = content?.buttons?.length && content?.buttons.map((button) => mapButtonProps(button?.button));

    return <ButtonCollection buttons={buttons} horizontal_alignment={content?.horizontal_alignment} />;
};
